import { useState } from "react";

export const DeveloperLogo = ({ dev, className = "h-20" }) => {
  const [failed, setFailed] = useState(false);
  const dark = dev.logo_bg === "dark";
  return (
    <div className={`w-full rounded-xl flex items-center justify-center px-4 ${dark ? "bg-[#25352C]" : "bg-white border border-pbs-line"} ${className}`} data-testid={`dev-logo-${dev.slug}`}>
      {dev.logo && !failed ? (
        <img src={dev.logo} alt={`${dev.name} logo`} loading="lazy" onError={() => setFailed(true)} className="max-h-[70%] max-w-[85%] object-contain" />
      ) : (
        <span className={`font-extrabold tracking-tight text-center leading-tight ${dark ? "text-white" : "text-pbs-plum"}`}>{dev.name}</span>
      )}
    </div>
  );
};

export default DeveloperLogo;
